import React from "react";

function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <p>&copy; {year} Minerva Credit Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;
